var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTogo = function SvgTogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.56 12.82c-.516 0-.846-.352-.846-.89V9.984l.165-1.77-1.637 1.748-4.143 4.156a.9.9 0 0 1-.66.264c-.494 0-.824-.33-.824-.847 0-.22.11-.45.275-.616l4.154-4.156 1.77-1.65-1.682.177H8.088c-.55 0-.901-.33-.901-.825 0-.506.34-.836.879-.836h5.374c.582 0 .945.264.945.935v5.344c0 .527-.33.912-.825.912"
  })));
};
export default SvgTogo;